import { Col, Container, Image, Row } from "react-bootstrap";
import MediaQueryTool from "../../utils/MediaQueryTool";
import randombg from "../../assets/Random31.jpg";
import maskbg from "../../assets/splash7.png";
import sugarno from "../../assets/pfp.png";
import splash from "../../assets/splash_starting.png";
import discord from "../../assets/discord.svg";
import phone from "../../assets/telephone.svg";
import insta from "../../assets/instagram.svg";
import email from "../../assets/envelope.svg";
import facebook from "../../assets/facebook.svg";

const Starting = () => {
  const mediaQueryTool = MediaQueryTool();

  return (
    <>
      {mediaQueryTool.isLG || mediaQueryTool.isXL ? (
        <div style={{ height: "110vh" }}>
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "110%",
              WebkitMaskImage: `url(${maskbg})`,
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskSize: "cover",
              maskImage: `url(${maskbg})`,
              maskRepeat: "no-repeat",
              maskSize: "cover",
            }}
          >
            <Image
              src={randombg}
              alt="Inner Content"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
          <Container style={{ zIndex: 2 }}>
            <Row
              style={{
                height: "100%",
                display: "flex",
              }}
            >
              <Col
                className="mx-5 d-md-flex flex-column justify-content-center align-items-center"
                style={{
                  transform: "rotate(-7deg)",
                  marginBottom: 150,
                  paddingLeft: 60,
                  marginTop: 140,
                }}
              >
                <Row>
                  <Container
                    className="neon-text"
                    style={{
                      fontFamily: "Neonderthaw",
                      fontSize: mediaQueryTool.isMD ? 90 : 275,
                    }}
                  >
                    Sugarno
                  </Container>
                </Row>
                <Row>
                  <h5
                    className="flicker-fast"
                    style={{
                      color: "#DFF9FB",
                      fontFamily: "NothingYouCouldDo",
                      fontSize: 50,
                      marginTop: -40,
                    }}
                  >
                    Freelancer Artist
                  </h5>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        <div>
          <Container
            style={{
              zIndex: 2,
            }}
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Image
                style={{
                  position: "absolute",
                  marginTop: -60,
                  marginLeft: 60,
                  width: "32rem",
                  height: "32rem",
                  zIndex: -1,
                }}
                src={splash}
              />

              <Image
                style={{
                  marginTop: 90,
                  width: "13rem",
                  height: "13rem",
                }}
                src={sugarno}
              />
              <Row
                style={{
                  height: "100%",
                  display: "flex",
                  transform: "rotate(-9deg)",
                }}
              >
                <Col
                  className="flex-column"
                  style={{
                    marginTop: -90,
                  }}
                >
                  <Row>
                    <Container
                      className="neon-text"
                      style={{
                        fontFamily: "Neonderthaw",
                        fontSize: mediaQueryTool.isMD ? 90 : 80,
                      }}
                    >
                      Sugarno
                    </Container>
                  </Row>
                  <Row>
                    <h5
                      className="flicker-fast"
                      style={{
                        color: "#DFF9FB",
                        fontFamily: "NothingYouCouldDo",
                        fontSize: mediaQueryTool.isMD ? 25 : 17,
                        marginTop: -5,
                        marginLeft: 80,
                      }}
                    >
                      Freelancer Artist
                    </h5>
                  </Row>
                </Col>
              </Row>
            </div>
            <div>
              <div
                style={{
                  marginLeft: 30,
                  marginTop: 30,
                  fontSize: 20,
                  padding: "10px 30px",
                  color: "white",
                  display: "flex",
                  flexDirection: "column",
                  transform: "rotate(-6deg)",
                }}
              >
                <a
                  href="tel:+60172496409"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  <Image
                    height={20}
                    width={20}
                    src={phone}
                    style={{ marginRight: 10 }}
                  />
                  +6017-249 6409
                </a>
                <a
                  href="mailto:sugarnno@gmail.com"
                  className="mt-2"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  <Image
                    height={20}
                    width={20}
                    src={email}
                    style={{ marginRight: 10 }}
                  />
                  sugarnno@gmail.com
                </a>
                <a
                  href="https://www.instagram.com/sugarno99?igsh=aHFiemdvMjh5cmNo"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  <Image
                    height={20}
                    width={20}
                    src={insta}
                    style={{
                      marginRight: 10,
                    }}
                  />
                  sugarno99
                </a>
                <a
                  href="https://www.facebook.com/share/14sRJ5gQ4z/"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  <Image
                    height={20}
                    width={20}
                    src={facebook}
                    style={{ marginRight: 10 }}
                  />
                  Sugar No
                </a>
                <div className="mt-2">
                  <Image
                    height={20}
                    width={20}
                    src={discord}
                    style={{ marginRight: 10 }}
                  />
                  amiraraja
                </div>
              </div>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default Starting;
